import axios from "axios";
import { Dropdown } from "react-bootstrap";
import { GearFill, ThreeDotsVertical } from "react-bootstrap-icons";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
import UploadImageToPostModal from "./modals/UploadImageToPostModal";
import DeleteImageModal from "./modals/DeleteImageModal";
import ClubPostUpdated from "./modals/ClubPostUpdated";
import LoadingSpinner from "../../components/LoadingSpinner";

export default function EditPost() {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [complete, setComplete] = useState(false);
  const [clubId, setClubId] = useState("");
  const { user, dispatch } = useAuthContext();

  const [imgActiveModal, setImgActiveModal] = useState(false);
  const [images, setImages] = useState([]);
  const [selectedImageId, setSelectedImageId] = useState(null);
  const [deleteImageModal, setDeleteImageModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showImages, setShowImages] = useState(false);
 const navi = useNavigate()
  const cancelModal = () => {
    setDeleteImageModal(false);
    setImgActiveModal(false);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  const updateClubPost = {
    id,
    clubId,
    title,
    content,
  };

  try {
    const updateReponse = await axios.put(
      `${ApiConnectionString}/api/ClubPost/${id}`,
      updateClubPost,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (updateReponse.status === 200) {
      setComplete(true);
    }
  } catch (error) {
    console.error("Error updating club post:", error);
    // Optionally set an error state here
  } finally {
    setIsLoading(false);
  }
};



  const fetchData = async () => {
    setIsLoading(true);
    try {
      const clubPostResponse = await axios.get(
        `${ApiConnectionString}/api/ClubPost/${id}`
      );
      if (clubPostResponse.status === 200) {
        setTitle(clubPostResponse.data.title);
        setContent(clubPostResponse.data.content);
        setClubId(clubPostResponse.data.clubId);
      }

      const imageResponse = await axios.get(
        `${ApiConnectionString}/api/images?ClubPostId=${id}`
      );
      setImages(imageResponse.data);
    } catch (error) {
      if (error.status === 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching club post or images:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }

    return () => clearTimeout(timeout);
  }, [deleteImageModal, imgActiveModal, user]);

  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    return (
            <div className="d-flex justify-content-center">

                       <button
        className="floating-back-button"
        onClick={() => navi(`/myoneclub/${clubId}`)}
      >
        ← Back to Club Page
      </button>
      <div className="container bg-white rounded m-5">
        <h3 className="fw-bold mt-4">Edit Post</h3>
        <button onClick={() => setImgActiveModal(true)} className="btn btn-secondary mb-3">
          Add Image
        </button>

        {images.length > 0 && !showImages && (
          <button
            onClick={() => setShowImages(true)}
            className="btn btn-outline-primary mb-3"
          >
            Show Post Images
          </button>
        )}

              {images.length > 0 && showImages && (
          <button
            onClick={() => setShowImages(false)}
            className="btn btn-outline-primary mb-3"
          >
            Hide Post Images
          </button>
        )}

        {showImages && images.length > 0 && (
          <div className="row g-3 mb-4">
            {images.map((image) => (
              <div key={image.id} className="col-12 col-md-4 col-lg-3">
                
                <div className="card position-relative h-100">
                          <div className="">
                    <Dropdown>
                      <Dropdown.Toggle
                        as="span"
                        className="dropdown-toggle-custom"
                      >
                        <GearFill 
                        className="mb-1"
                        size={35}
                          style={{ cursor: "pointer" }}
                          onClick={() => setSelectedImageId(image.id)}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setDeleteImageModal(true)}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div className="ratio ratio-4x3">
                    <img
                      src={`${ApiConnectionString}/api/image/${image.id}`}
                      alt="Club"
                      className="w-100 h-100 object-fit-cover rounded-top"
                    />
                  </div>
          
                  {image.mainImage && (
                    <div className="card-body">
                      <p className="card-text text-primary fw-bold mb-0">Main Image</p>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

<form onSubmit={handleSubmit} className="mt-4">
  <div className="form-group mb-3">
    <label htmlFor="title" className="form-label">Title</label>
    <input
      type="text"
      id="title"
      className="form-control"
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      required
    />
  </div>

  <div className="form-group mb-4">
    <label htmlFor="content" className="form-label">Content</label>
    <textarea
      id="content"
      className="form-control"
      value={content}
      onChange={(e) => setContent(e.target.value)}
      rows="4"
      required
    />
  </div>

<div className="d-flex justify-content-center"> 
 <button type="submit" className="saveChanges-button mb-5 px-5">
            Update
          </button>
</div>
   
</form>

        {complete && <ClubPostUpdated id={clubId} />}
        {imgActiveModal && (
          <UploadImageToPostModal id={id} cancelModal={cancelModal} />
        )}
        {deleteImageModal && (
          <DeleteImageModal id={selectedImageId} cancelModal={cancelModal} />
        )}
      </div>
          </div>
    );
  }
}
